import React, { useState, useEffect } from 'react';
import { List } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { post } from '@/common/request';
import cs from 'classnames';
import { customerStore } from '@/store';
import styles from './index.module.less';
import { dispatchNavigate } from '@/common/document-event/dispatch';
import { getCookie, setCookie, removeStorage, setStorage } from '@lhb/cache';
import Modal from '@/common/components/Modal/Modal';
import { getTokenMerge } from '@/utils/ways';
import { isObject } from '@lhb/func';

interface AccountModalProps {
  showChangeAccount: Function;
  showAccountModal: boolean;
  initToken?: string
}

const { getList } = customerStore;


const ChangeAccount: React.FC<AccountModalProps> = ({ showChangeAccount, showAccountModal }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [enterprisesList, setEnterprisesList] = useState<any[]>([]);

  useEffect(() => {
    showAccountModal ? getEnterprises() : setLoading(true);

  }, [showAccountModal]);

  // 获取企业信息
  const getEnterprises = () => {
    getList(getCookie('loginToken') || getTokenMerge(), {
      headers: {
        token: getCookie('loginToken') || getTokenMerge(),
      }
    }).then((data) => {
      setEnterprisesList(data);
      setLoading(false);
    });
  };


  // 选择企业
  const intoHandle = async (enterprise: any) => {
    const { id } = enterprise;
    const params: any = {
      tenantId: id,
    };
    // https://yapi.lanhanba.com/project/307/interface/api/33540
    const res = await post('/tenant/chooseTenant', params, {
      needHint: true,
      proxyApi: '/mirage',
      headers: {
        token: getCookie('loginToken'),
      }
    });
    const { token } = res;
    if (token) {
      const customToken = window.customToken || 'newPmsToken';
      let timeWait = 100;
      if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
        if (isObject(token)) { // 如果是对象，就上报
          // 主动send事件
          window.LHBbigdata.send({
            event_id: 'location_pms_pc_cookie_monitoring_token', // 事件id
            msg: res, // 额外需要插入的业务信息
          });
          timeWait = 200;
        }
      }
      setCookie(customToken, token);
      setStorage(customToken, token);
      setStorage('getTokenApi', '/tenant/chooseTenant');
      showChangeAccount(false);
      dispatchNavigate('/');
      removeStorage('pageFilters');
      // 刷新数据
      setTimeout(() => {
        window.location.reload();
      }, timeWait);
    }
  };

  return (
    <Modal
      open={showAccountModal}
      title='选择账号进入首页'
      footer={false}
      onCancel={() => showChangeAccount(false)}
      width={600}
      maskClosable={false}
    >
      <List
        dataSource={enterprisesList}
        loading={loading}
        className={styles.listWrap}
        renderItem={(item: any) => (
          <div onClick={() => intoHandle(item)}>
            <List.Item>
              <List.Item.Meta
                description={
                  <div className={styles.item}>
                    <div className={cs(styles.flexItem)}>
                      <div>
                        {item.name}
                      </div>
                      <RightOutlined className='color-primary-operate pointer' onClick={() => intoHandle(item)} />
                    </div>
                  </div>
                }
              />
            </List.Item>
          </div>
        )}
      />
    </Modal>
  );
};

export default ChangeAccount;
